import api from '@/libs/axios'

export default {
  async create(payload) {
    const response = await api.post('/earns/admin/products', payload)
    return response.data.data.new_document || null
  },
  async update(payload) {
    let response = await api.put('/earns/admin/products', payload)
    return response
  },
  async delete(payload) {
    const response = await api.delete('/earns/admin/products', {
      data: payload,
    })
    return response
  },
  async getList(params) {
    let response = await api.get('/earns/admin/products', {
      params,
    })
    return response
  },
  async get(params) {
    let response = await api.get('/earns/admin/products/detail', {
      params,
    })
    return response.data.data.document || null
  },
}